import moment from "moment-timezone";
import Dinero from "dinero.js";
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Table, Icon } from "semantic-ui-react";

import ResourceMarker from "../marking/ResourceMarker.jsx";
import LinkWithReset from "../utils/LinkWithReset.jsx";

import { COST_FORMAT } from "../config.js";

class InvoiceRow extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired
  };

  render() {
    const { data } = this.props;

    const total = Dinero({
      amount: data.summary.total,
      currency: data.summary.currency
    }).setLocale("en-GB");

    return (
      <Table.Row textAlign="center">
        <Table.Cell textAlign="left">
          <LinkWithReset to={data["@id"]} className={"resource-icon"}>
            <Icon name="file alternate outline" /> {data.number}
          </LinkWithReset>
        </Table.Cell>
        <Table.Cell collapsing>
          {moment(data.startAt).utc().format("W")}
        </Table.Cell>
        <Table.Cell collapsing>
          {moment(data.startAt).utc().format("DD-MM-YY")}
        </Table.Cell>
        <Table.Cell collapsing>
          {moment(data.endAt).utc().format("DD-MM-YY")}
        </Table.Cell>
        <Table.Cell textAlign="left" collapsing>{` ${total.toFormat(
          COST_FORMAT
        )}`}</Table.Cell>
        <Table.Cell collapsing>
          <ResourceMarker
            marking={data.marking}
            circular={true}
            style={{ display: "block" }}
          />
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default InvoiceRow;
